import React from 'react';
import PropTypes from 'prop-types';

const Angle5Path = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 6C3.343 6 2 7.341 2 8.999v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-14A2.999 2.999 0 0 0 19 6H5zm3.66 3.999h6.8v2h-4.95l-.175 2.35A4.012 4.012 0 0 1 11.98 14C14.2 14 16 15.792 16 17.999 16 20.209 14.2 22 11.98 22A4.015 4.015 0 0 1 8 18.57h2.041a2.001 2.001 0 0 0 3.919-.571A2 2 0 0 0 11.959 16c-.586 0-1.112.252-1.479.654H8.162l.498-6.655zm22.222-2.371l-6.627 3.727a.503.503 0 0 0-.255.436v8.415c0 .181.098.348.255.437l6.627 3.727A.75.75 0 0 0 32 23.717V8.281a.752.752 0 0 0-.751-.75.75.75 0 0 0-.367.097z"
    />
  );
};

Angle5Path.propTypes = {
  fill: PropTypes.string,
};

export default Angle5Path;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/angle-5.jsx